module.exports = __webpack_public_path__ + "static/media/eth.39192451.svg";